import { render, staticRenderFns } from "./AddProductMultiple.vue?vue&type=template&id=476f57ed&scoped=true"
import script from "./AddProductMultiple.vue?vue&type=script&lang=js"
export * from "./AddProductMultiple.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/multiselect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AddProductMultiple.vue?vue&type=style&index=1&id=476f57ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f57ed",
  null
  
)

export default component.exports